export const removePropertyFromObject = (
  obj: any,
  propertyToBeRemoved: string
) => {
  let newObject: any = {};
  if (!isEmptyObject(obj)) {
    Object.entries(obj).forEach(([_key, _value]: any) => {
      if (_key != propertyToBeRemoved) {
        newObject[_key] = _value;
      }
    });
  }
  return isEmptyObject(newObject) ? obj : newObject;
};
export const isEmptyObject = (obj: any) => obj && Object.keys(obj).length === 0;

export const decimal_2_place = (num:any) => parseFloat(num).toFixed(2) !== "NaN" ? parseFloat(num).toFixed(2) : num;
